import { AppDataQuery, useAppDataQuery } from 'graphql/bindings/AdminBindings'
import { AuthClient } from 'graphql/clients'
import { CogIcon, NavbarProfileButton, SignOutAltIcon, UserIcon } from '@forgeglobal/design-framework'
import { useLogoutMutation } from 'graphql/bindings/AuthBindings'
import EnvVars from 'util/EnvVars'
import ProfilePicture from 'components/shared/ProfilePicture'
import React from 'react'

export default () => {
  const { data } = useAppDataQuery()

  const getName = (query?: AppDataQuery) =>
    query && query.currentAdmin ? [query.currentAdmin.first_name, query.currentAdmin.last_name].join(' ') : ''

  const [signOut] = useLogoutMutation({ client: AuthClient })
  const clickSignout = () => {
    signOut().then(() => {
      const currentUrl = window.location.href
      window.location.href = `${EnvVars.PLATFORM_URL}/login?redirect=${currentUrl}`
    })
  }
  return (
    (data && data.currentAdmin && (
      <NavbarProfileButton
        avatar={<ProfilePicture />}
        firstLine={getName(data)}
        secondLine={data.currentAdmin.email}
        listItems={[
          { text: 'Profile', link: '/profile', icon: <UserIcon /> },
          { text: 'Settings', link: '/settings', icon: <CogIcon /> },
          { text: 'Sign out', link: '/settings', icon: <SignOutAltIcon />, onClick: clickSignout },
        ]}
      />
    )) ||
    null
  )
}
